import Login from '../pages/LoginPage'
import PrivacyPage from '../pages/PrivacyPage'
import ProfilePage from '../pages/ProfilePage'
import SignUpPage from '../pages/SignUpPage'
import ForgotMyPasswordPage from '../pages/ForgotMyPasswordPage'
import RecoverMyPasswordPage from '../pages/RecoverMyPasswordPage'
import SuccessRecoverPasswordPage from '../pages/SuccessRecoverPasswordPage'

import AdminTemplate from '../components/template/AdminTemplate'
import PublicTemplate from '../components/template/PublicTemplate'

import withUrlParams from '../utils/withUrlParams'
import ChangeTemporaryPasswordPage from '../pages/ChangeTemporaryPasswordPage'

/**
 * Only logged users can access these routes
 */
export const privateRoutes = [
  {
    path: '/',
    component: ProfilePage,
    default: true
  }
].map(route => ({
  ...route,
  component: withUrlParams(route.component),
  template: AdminTemplate
}))

/**
 * Only not logged users can access these routes
 */
export const notLoggedRoutes = [
  ...[
    '/',
    '/login'
  ].map(path => ({ path, component: Login })),
  {
    path: '/signup',
    component: SignUpPage
  },
  {
    path: '/forgot-my-password/:token?',
    component: ForgotMyPasswordPage
  },
  {
    path: '/recover_password/:token',
    component: RecoverMyPasswordPage
  },
  {
    path: '/success_recover_password',
    component: SuccessRecoverPasswordPage
  },
  {
    path: '/change_temporary_password',
    component: ChangeTemporaryPasswordPage
  }
].map(route => ({
  ...route,
  template: PublicTemplate
}))

/**
 * Both logged and not logged users can access these routes
 */
export const publicRoutes = [
  {
    path: '/privacy',
    component: PrivacyPage
  }
]
